import { render, staticRenderFns } from "./AutomaticRoomAsignation.vue?vue&type=template&id=00810fa6&"
import script from "./AutomaticRoomAsignation.vue?vue&type=script&lang=js&"
export * from "./AutomaticRoomAsignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports